import { default as _91_46_46_46slug_93tTVZEUyhkLMeta } from "/home/circleci/project/pages/[...slug].vue?macro=true";
import { default as indexbVK8ERtDnaMeta } from "/home/circleci/project/pages/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46slug_93tTVZEUyhkLMeta?.name ?? "slug",
    path: _91_46_46_46slug_93tTVZEUyhkLMeta?.path ?? "/:slug(.*)*",
    meta: _91_46_46_46slug_93tTVZEUyhkLMeta || {},
    alias: _91_46_46_46slug_93tTVZEUyhkLMeta?.alias || [],
    redirect: _91_46_46_46slug_93tTVZEUyhkLMeta?.redirect || undefined,
    component: () => import("/home/circleci/project/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexbVK8ERtDnaMeta?.name ?? "index",
    path: indexbVK8ERtDnaMeta?.path ?? "/",
    meta: indexbVK8ERtDnaMeta || {},
    alias: indexbVK8ERtDnaMeta?.alias || [],
    redirect: indexbVK8ERtDnaMeta?.redirect || undefined,
    component: () => import("/home/circleci/project/pages/index.vue").then(m => m.default || m)
  }
]